<div class="fulfillmentLanding container-return-wrapper associate-crop-landing">
  <div class="containerReturnsLandingPage">
    <div class="row">
      <div class="col-12 mb-3">
        <h3>
          Order Inquiry
        </h3>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (exportClick)="export()" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div>
        <button mat-raised-button class="btns xs-button xs-full-width exportBtn" [disabled]="(associateDataSource && associateDataSource.data.length == 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <div class="d-flex justify-content-end btnWrap">
          <button mat-raised-button class="btns newOrderBtn" color="primary" (click)="generateReport()">Inventory Availability Report</button>&nbsp;&nbsp;
          <button *ngIf="!readOnlyAccess" mat-raised-button class="btns newOrderBtn" color="primary" (click)="createNewReturn()">Create New Order</button>
        </div>
        <mat-tab-group  class="matTabs prepayLandingTab">
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Associate Crop Orders
                </h4>
                <p class="subhead">
                  View Your Associate Crop Orders
                </p>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #associatePaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #associateTable [dataSource]="associateDataSource" matSort #associateSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="orderHeaderID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Order Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="navigateOrderDetail(element)">
                      <u>
                        <p class="accNo">
                          {{element.orderHeaderID}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="shipToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.shipToAccount}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Account</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    <div class="order-info">
                      <p class="accName">
                        {{element.shipToAccount}} - {{element.accountName}}
                      </p>
                      <p class="accName">{{element.shipToCity}}, {{element.shipToState}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="associateName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Associate Location</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    <div class="order-info">
                      <p class="accName">
                        {{element.associateName}},
                      </p>
                      <p class="accName">{{element.associateCity}},{{element.associateState}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Request By Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="brand">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Variety</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.brand}} </td>
                </ng-container>
                <ng-container matColumnDef="orderQty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Ordered Qty</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderQty}} </td>
                </ng-container>
                <ng-container matColumnDef="orderUOM">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">UOM</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderUOM}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.status}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="associateOrderColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: associateOrderColumns;"></tr>
              </table>
              <div *ngIf="associateDataSource == undefined || (associateDataSource && associateDataSource.data.length == 0)" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

